export default __webpack_public_path__ + "static/media/83Bar-white.d0ee9f0a.png";